module.exports = __webpack_public_path__ + "static/media/Agri-producer_Needs_19-02-2024-removebg-preview (1).df2ccf9f.png";